import { Component, OnInit } from "@angular/core";
import { Validators, FormBuilder } from "@angular/forms";
import { MainService } from "src/app/Services/service.service";
import { Router } from "@angular/router";
import { MatDialogRef } from "@angular/material";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.css"]
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm = this.fb.group({
    email: [null, Validators.compose([Validators.required, Validators.email])]
  });
  constructor(private fb: FormBuilder, public services: MainService, private route: Router, public dialogRef: MatDialogRef<ResetPasswordComponent>) {}
  isEmailNotValid() {
    return this.resetPasswordForm.controls["email"].hasError("required") || this.resetPasswordForm.controls["email"].hasError("email");
  }

  private _sendingInProgress=false;

  get sendingInProgress(): boolean {
    return this._sendingInProgress;
  }

  set sendingInProgress(value: boolean) {
    this._sendingInProgress = value;
  }

  getEmailErrorMessage() {
    return this.resetPasswordForm.controls["email"].hasError("required") ? "Email is required" : this.resetPasswordForm.controls["email"].hasError("email") ? "Enter valid email address" : "";
  }
  ngOnInit() {}

  public afterRegClose:boolean = false
  onSubmit() {
    if (!this.resetPasswordForm.invalid) {
      this.sendingInProgress=true;
      this.services.userService
        .resetPassword(this.resetPasswordForm.controls["email"].value, "")
        .then(r => {
          this.sendingInProgress=false;
          this.services.showInformation("We sent you an email with instructions how to reset your password");
          this.services.route.navigate([r]);
          this.afterRegClose = true;
          this.dialogRef.close();
        })
        .catch(e => {
          this.sendingInProgress=false;
          this.services.showError(e);
        });
    }
  }
}
